<template>
    <div class="selectMenu">
        <vue-drag-resize :isActive="true" :isDraggable="false" :w="260" :minw="260" :parentW="500" axis="x"
            :sticks="['mr']" v-on:resizing="resize" class="VueDragResize" :preventActiveBehavior="true"
            :parentLimitation="true">
            <div class="aside">
                <div class="title">
                    已选择的推广内容
                    <ig-icon class="drag-right" name="tuozhuai"></ig-icon>
                </div>
                <div class="areaItem">
                    <div v-for="(item,index) in proArr" :key="index"
                    :class="['item', selectedVal == item.automationContentId ? 'selectitem' : 'item', (fatherComponent==='promotionMaterial'&&item.titleFlag === 0 )? 'onlyRead' : 'item',(fatherComponent==='confirmKeyword'&&item.keywordFlag === 0 )? 'onlyRead' : 'item']"
                    @click="changeIndex(item,item.automationContentId,index)">
                    <i class="el-icon-success" style="color: #34D04C ; font-size: 20px; "
                        v-if="(fatherComponent==='promotionMaterial'&&item.titleFlag === 1) || (fatherComponent==='confirmKeyword'&&item.keywordFlag === 1)">
                    </i>{{ item.title }}
                    </div>
                </div>
            </div>
        </vue-drag-resize>
    </div>
</template>
<script>
export default {
    props: ['proArr',  'selecteditem','fatherComponent'],
    data() {
        return {
            selected: {},
            selectedArr:[],
            selectedVal: '',
            selctedindex: '',
            width: 260,
            height: 0,
            top: 0,
            left: 0,
            windowWidth: document.documentElement.clientWidth - 260 - 10,
        };
    },
    methods: {
        changeIndex(item, val, index) {
            this.selectedArr.push(item);
            this.selected = item;
            this.selectedVal = val;
            this.selctedindex = index;
            this.$emit('getselectedItem', item,this.selectedArr);
        },
        handleResize(event) {
            this.windowWidth = document.documentElement.clientWidth - 260; // 宽
        },
        resize(newRect) {
            this.width = newRect.width;
            this.height = newRect.height;
            this.top = newRect.top;
            this.left = newRect.left;
            this.$emit('getWidth', this.boxWidth, this.width)
        },
    },
    computed: {
        boxWidth() {
            return this.windowWidth - this.width + 20;
        },
    },
    watch: {
        selecteditem: {
            handler(val) {
                this.selectedVal = val.automationContentId;
            }
        },
    },
    mounted() {
        // this.selectedVal = this.selectedval;
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.handleResize);
    },
}
</script>
<style lang="scss" scoped>
.selectMenu {
    .VueDragResize {
        top: unset !important;
        left: unset !important;
        height: 0 !important;

        .aside {
            overflow: hidden;
            background: #ffffff;
            height: 600px;

            .title {
                margin: 18px 20px;
                font-size: 18px;
                font-weight: 600;

                .drag-right {
                    color: #999;
                    float: right;
                    line-height: 30px;
                }
            }
            .areaItem{
                height: 520px;
                overflow-y: auto;
            }

            .onlyRead{
                pointer-events: none;
                // cursor:not-allowed;
            }
            .item {
                height: 40px;
                line-height: 40px;
                padding: 0 18px;
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                white-space: nowrap; //溢出不换行
                cursor: pointer;
            }

            .selectitem {
                background: #ebf5ff;
                color: #3da1ff;
                border-radius: 4px;
                cursor: pointer;
            }
        }
    }
}
</style>